<template>
    <div v-loading="isSuccess">
        <div class="PaperDetails">
            <img class="imgBanner" :src="detailsData.coverurl" alt="">
            <div class="paperInfo margin_bottom20">
                <div class="infoTop">
                    <div class="report_subject_box" id="reportSubjectBox">
                        <div class="subject" id="subjectDiv" :class="{inline: !subjectIsPackup}">
                            {{ detailsData.subject }}
                            <div class="handleIconBox" :class="{packup: subjectIsPackup}" @click="handleChangeSubjectIsPackup" v-if="showSubjectHandle">
                                <img class="subjectHandle" :src="require('@/common/images/course/unfold_packup.png')" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="report_subject_box" id="reportSubjectBox">
                        <span class="subject" id="subjectDiv" :class="{inline: !subjectIsPackup}">{{ detailsData.subject }}</span>
                        <div class="handleIconBox" :class="{packup: subjectIsPackup}" @click="handleChangeSubjectIsPackup" v-if="showSubjectHandle">
                        <img class="subjectHandle" :src="require('@/common/images/course/unfold_packup.png')" />
                        </div>
                    </div> -->
                    <!-- <p>{{detailsData.subject}}</p> -->
                    <div class="redText">
                        <span class="saleprice" v-if="detailsData.feetype===1">免费</span>
                        <span class="saleprice" v-if="detailsData.feetype===2  && (!detailsData.zjmemtype || (detailsData.zjmemtype === 2 && detailsData.plusprice == 0))"><span class="unit">￥</span>{{ detailsData.saleprice }}</span>
                        <span class="uprice" v-if="detailsData.feetype===2 && detailsData.uprice !== '0.00'  && (!detailsData.zjmemtype || (detailsData.zjmemtype === 2 && detailsData.plusprice == 0))">￥{{detailsData.uprice}}</span>
                        <div class="div_price" v-if="detailsData.feetype === 2 && detailsData.zjmemtype && !user.zjmemtype && detailsData.plusprice > 0">
                            <span class="saleprice">￥{{ detailsData.saleprice }}</span>
                            <img :src="require('@/common/images/course/plus_price_icon1.png')" class="plusPriceIcon1" alt="">
                            <span class="plusPrice">￥{{ detailsData.plusprice }}</span>
                        </div>
                        <div class="div_price" v-if="detailsData.feetype === 2 && detailsData.zjmemtype && user.zjmemtype && detailsData.plusprice > 0">
                            <div class="saleprice">¥{{detailsData.plusprice}}</div>
                            <img :src="require('@/common/images/course/plus_price_icon2.png')" class="plusPriceIcon2" alt="">
                            <span class="plusPrice">原价：￥{{ detailsData.saleprice }}</span>
                        </div>
                    </div>
                    <div class="memberTips" @click="handleGoMemberDetails">
                        <div class="iconTips">
                            <img :src="require('@/common/images/course/member_icon_mobile.png')" class="memberIcon" alt="">
                            <div class="tips">加入蓝鲸会员享受更多权益！</div>
                        </div>
                        <img :src="require('@/common/images/course/arrow_icon_mobile.png')" class="arrowIcon" alt="">
                    </div>
                </div>
                <div class="infoBottom">
                    <p><span class="label">报告年份</span><span>{{detailsData.reportyear}}年</span></p>
                    <p><span class="label">所属行业</span><span>{{detailsData.firstcodename}} {{detailsData.secondcodename}}</span></p>
                    <p><span class="label">发布机构</span><span>{{detailsData.hostname}}</span></p>
                </div>
            </div>
            <!--选项卡-->
            <div class="tab_wrap">
                <van-tabs @change="tabChange" sticky v-model="active">
                    <van-tab title="详情">
                        <div class="no_data_box" v-if="detailsData.repintro===''">
                            <img :src="require('@/common/images/report/no_dataImg.png')" alt="">
                            <span>当前暂无报告简介</span>
                        </div>
                        <div class="introduce_box" v-else v-html="detailsData.repintro"></div>
                    </van-tab>
                    <van-tab title="目录">
                        <div class="no_data_box" v-if="detailsData.repdirectory===''">
                            <img :src="require('@/common/images/report/no_dataImg.png')" alt="">
                            <span>当前暂无报告目录</span>
                        </div>
                        <div class="introduce_box" v-else v-html="detailsData.repdirectory"></div>
                    </van-tab>
                </van-tabs>
            </div>
            <!--底部-->
            <footer>
                <div class="footer_left">
                    <div @click="goHome"><img :src="require('@/common/images/report/mobile/mIndex_icon.png')" alt=""><p>首页</p></div>
                    <div @click="collectionClick(detailsData.isfavorite)">
                        <img :src="detailsData.isfavorite === 1 ? require('@/common/images/report/mobile/mYellowStar.png') : require('@/common/images/report/mobile/mGrayStar.png')" alt="">
                        <p :class="detailsData.isfavorite === 1 ? 'yellow_text' : ''">{{detailsData.isfavorite === 0 ? '收藏' : '取消'}}</p>
                    </div>
                </div>
                <div class="footer_right">
                    <!-- <van-button type="warning" v-if="detailsData.ispreview===1&&detailsData.isjoin===0" @click="goPreview"><img :src="require('@/common/images/report/mobile/mPreview.png')" alt="">预览报告</van-button> -->
                    <van-button type="primary" v-if="detailsData.feetype===1&&detailsData.isjoin===0" @click="freeGet"><img :src="require('@/common/images/report/mobile/mFree.png')" alt="">免费获取</van-button>
                    <van-button type="warning openPlus" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && detailsData.zjmemtype && !user.zjmemtype && detailsData.plusprice > 0" @click="handleGoMemberDetails(1)">开通PLUS会员</van-button>
                    <van-button type="warning upgrade" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && detailsData.zjmemtype && user.zjmemtype === 1 && detailsData.plusprice > 0" @click="handleGoMemberDetails(2)">升级蓝鲸年卡</van-button>
                    <van-button type="warning upgrade" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && detailsData.zjmemtype === 2 && detailsData.plusprice == 0" @click="handleGoMemberDetails(2)">开通蓝鲸年卡</van-button>
                    <van-button type="primary" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && ((detailsData.zjmemtype && !user.zjmemtype) || (detailsData.zjmemtype === 2 && user.zjmemtype === 1) || (detailsData.zjmemtype === 2 && detailsData.plusprice == 0))" @click="buyNow"><img :src="require('@/common/images/report/mobile/mCar.png')" alt="">直接购买</van-button>
                    <van-button type="primary" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0 && (!detailsData.zjmemtype || (detailsData.zjmemtype === 1 && user.zjmemtype === 1) || (detailsData.zjmemtype === 1 && user.zjmemtype === 2))" @click="buyNow"><img :src="require('@/common/images/report/mobile/mCar.png')" alt="">立即购买</van-button>
                    <van-button type="info"  v-if="detailsData.isdownload===1&&detailsData.isjoin===1" @click="downReport"><img :src="require('@/common/images/report/mobile/mDown.png')" alt="">下载报告</van-button>
                    <van-button type="warning" v-if="detailsData.isjoin===1" @click="goPreview"><img :src="require('@/common/images/report/mobile/mPreview.png')" alt="">查看报告</van-button>
                </div>
            </footer>
        </div>
        <!-- <BindMobile ref="bindMobile" /> -->
    </div>

</template>

<script>
    import {getWXSDKSetting} from 'common/js/wxSDKSetting'
    import {getReportDetail,updateJoinReport} from 'api/reportApi'
    import {uploadCourseFavorite} from 'api/api'
    import {mapGetters, mapActions} from 'vuex'
    import {Toast} from 'vant'
    import $ from 'jquery'
    export default {
        name: 'MReportDetails',
        metaInfo: {
        meta: [
                { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=no' }
            ]
        },
        data() {
            return {
                isSuccess:true, //数据是否加载完成
                detailsData:{},
                active:0,
                showSubjectHandle: false,
                subjectIsPackup: true
            }
        },
        created() {
            if(!this.domainInfo.isMobile){
                this.$router.push({
                    name: 'ReportDetails',
                    query: {'reportid': this.$route.query.reportid, chid: this.$route.query.chid ? this.$route.query.chid : ''}
                })
            }
        },
        activated () {
            if (this.refresh) {
                this._getList();
                this.setRefresh(false)
            }
        },
        mounted(){
            if (!this.refresh) {
                this._getList()
            }
        },
        methods:{
            //课程导航tab切换
            tabChange(){

            },
            _isWixin() {
                let ua = window.navigator.userAgent.toLowerCase();
                if (/micromessenger/.test(ua)) {
                    return true
                } else {
                    return false
                }
            },
            //获取详情
            _getList(){
                this.setLoading(true);
                let params = {
                    reportid: this.$route.query.reportid,
                    channelid: this.$route.query.chid ? this.$route.query.chid : ''
                };
                getReportDetail({
                    data: Object.assign({}, params),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.isSuccess=false;
                        this.detailsData = data.data;
                        this.goTop();
                        if (this._isWixin()) {
                            let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?reportid=' + this.$route.query.reportid + '&chid=' + (this.$route.query.chid ? this.$route.query.chid : '');
                            getWXSDKSetting({
                                title: this.detailsData.subject,
                                desc: this.detailsData.sharecontent,
                                link: link,
                                imgUrl: this.detailsData.coverurl
                            })
                        }
                        this.$nextTick(() => {
                            let subjectHeight = document.getElementById('subjectDiv').offsetHeight
                            let subjectBoxHeight = document.getElementById('reportSubjectBox').offsetHeight
                            if (subjectHeight - subjectBoxHeight > 10) {
                                this.showSubjectHandle = true
                            } else {
                                this.showSubjectHandle = false
                            }
                        })
                    },
                    error: data => {
                        this.isSuccess = true;
                        Toast(data.msg);
                    }
                })
            },
            handleChangeSubjectIsPackup() {
                this.subjectIsPackup = !this.subjectIsPackup
                this.$nextTick(() => {
                if (this.subjectIsPackup) {
                    document.getElementById('reportSubjectBox').style.height = 'auto'
                    document.getElementById('reportSubjectBox').style.maxHeight = '0.84rem'
                } else {
                    document.getElementById('reportSubjectBox').style.height = document.getElementById('subjectDiv').offsetHeight + 'px'
                    document.getElementById('reportSubjectBox').style.maxHeight = document.getElementById('subjectDiv').offsetHeight + 'px'
                }
                })
            },
            // 免费获取
            freeGet(){
                this.setLoading(true);
                let params = {
                    reportid: this.$route.query.reportid,
                    channelid: this.$route.query.chid ? this.$route.query.chid : ''
                };
                updateJoinReport({
                    data: Object.assign({}, params),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        Toast('你已获取成功！');
                        this._getList();
                        // this.detailsData.isjoin=1
                    },
                    error: data => {
                        Toast(data.msg);
                    }
                })
            },
            // 去会员详情页面 zjmemtype: 1为PLUS卡 2为年卡
            handleGoMemberDetails(zjmemtype) {
                console.log(zjmemtype)
                this.$router.push({name: 'MMemberDetails', query: {chid: this.$route.query.chid ? this.$route.query.chid : ''}})
            },
            // 立即购买
            buyNow() {
                if(this.user.isLogin===true){
                    this.$router.push({name: 'MConfirmOrder', query: {reportid: this.detailsData.reportid, kmctype: 2}})
                }else{
                    this.$router.push({name: 'MLogin'})
                }
            },
            // 预览报告
            goPreview(){
                if(this.user.isLogin===true){
                    this.setRefresh(true);
                    // 查看
                    if(this.detailsData.isjoin===1){
                        this.$router.push({name: 'MReportPreview', query: {'reportid': this.detailsData.reportid,retype:1}})
                    }else{  // 预览
                        this.$router.push({name: 'MReportPreview', query: {'reportid': this.detailsData.reportid,retype:2}})
                    }
                }else{
                    this.$router.push({name: 'MLogin'})
                }
            },
            // 下载报告
            downReport(){
                window.open(this.detailsData.fullfileurl)
            },
            // 收藏课程
            collectionClick(val) {
                this.setLoading(true);
                let params = {
                    courseid: this.$route.query.reportid,
                    optype: val === 1 ? 2 : 1,
                    kmctype:2,
                };
                uploadCourseFavorite({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        if(data.code === '000') {
                            if(val === 1) {
                                this.detailsData.isfavorite = 0;
                                Toast('已取消收藏')
                            } else {
                                this.detailsData.isfavorite = 1;
                                Toast('收藏成功')
                            }
                        }
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            },
            //回到首页
            goHome() {
                this.$router.push({name:'MReportIndex'})
            },
            // 回到顶部
            goTop() {
                $("html,body").animate({
                    scrollTop: 0
                },200)
            },
            ...mapActions([
                'setLoading',
                'setRefresh',
            ])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters(['refresh', 'user','domainInfo'])
        },
        components: {
            
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .PaperDetails{
        .imgBanner{
            width: 100%;
            height: 4.22rem;
            background: #eee;
        }
        .paperInfo{
            background: #fff;
            align-items: center;
            .infoTop{
                border-bottom: 1px solid #eee;
                padding: 0.28rem 0.32rem;
                .report_subject_box {
                    position: relative;
                    height: auto;
                    max-height: 0.84rem;
                    overflow: hidden;
                    transition: all 0.3s;
                    margin-bottom: 0.2rem;
                    .subject {
                        font-size: 0.36rem;
                        color: #333333;
                        font-weight: bold;
                        display: inline-block;
                        line-height: 0.42rem;
                        &.inline {
                            display: inline;
                        }
                    }
                    .handleIconBox {
                        display: inline-block;
                        width: 0.38rem;
                        height: 0.38rem;
                        background: #fff;
                        text-align: center;
                        line-height: 0.38rem;
                        position: relative;
                        bottom: -0.08rem;
                        .subjectHandle {
                            width: 0.24rem;
                            height: 0.12rem;
                            transform: rotate(180deg);
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            margin: auto;
                        }
                        &.packup {
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .subjectHandle {
                                transform: rotate(0);
                            }
                        }
                    }
                }
                .redText{
                    color: #F56C6C;
                    .saleprice{
                        font-size: 0.36rem;
                        .unit {
                            font-size: 0.32rem;
                        }
                    }
                    .uprice{
                        font-size: 0.2rem;
                        color: #666666;
                        margin-left: 0.12rem;
                        text-decoration: line-through;
                    }
                    .div_price {
                        display: flex;
                        align-items: center;
                        .plusPriceIcon1 {
                            width: 1.13rem;
                            height: 0.32rem;
                            margin: 0 0.05rem 0 0.18rem;
                        }
                        .plusPriceIcon2 {
                            width: 0.8rem;
                            height: 0.32rem;
                            margin: 0 0.05rem 0 0.18rem;
                        }
                        .plusPrice {
                            font-size: 0.24rem;
                            color: #666666;
                        }
                    }
                }
                .memberTips {
                    width: 100%;
                    background: #FFF8E6;
                    border-radius: 0.1rem;
                    padding: 0 0.2rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 0.52rem;
                    margin-top: 0.28rem;
                    box-sizing: border-box;
                    .iconTips {
                        display: flex;
                        align-items: center;
                        .memberIcon {
                            width: 0.3rem;
                            height: 0.3rem;
                            margin-right: 0.1rem;
                        }
                        .tips {
                            font-size: 0.26rem;
                            color: #BB7221;
                            font-weight: bold;
                        }
                    }
                    .arrowIcon {
                        width: 0.12rem;
                        height: 0.24rem;
                    }
                }
            }
            .infoBottom{
                padding: 0.28rem 0.32rem;
                p{
                    margin-bottom: 0.28rem;
                    font-size: 0.24rem;
                    color: #666;
                    .label{
                        margin-right: 0.22rem;
                        display: inline-block;
                        text-align-last: justify;
                    }
                }
                p:last-child{
                    padding-bottom: 0;
                    margin-bottom: 10px;
                }
            }
        }
        .tab_wrap{
            padding-bottom: 1.2rem;
            margin-top: 0.2rem;
            .introduce_box {
                background: #fff;
                padding: 0.32rem;
                font-size: 0.28rem;
                line-height: 0.48rem;
                * {
                    max-width: 100%;
                    line-height: 0.48rem;
                }
                img{
                    width: 100%;
                }
            }
            /*无数据时样式*/
            .no_data_box {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0.5rem 0;
                background: #fff;
                &>img{
                    width: 1.40rem;
                    height: 1.17rem;
                }
                &>span {
                    margin-top: 0.3rem;
                    color: #999;
                    font-size: 0.24rem;
                    line-height: 0.4rem;
                }
            }

            .catalogBox{
                .catalogList:last-child{
                    margin-bottom: 0;
                }
                .catalogList{
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0.3rem;
                    .title{
                        width: 4.5rem;
                    }
                    .examination{
                        width:1rem;
                        height:0.46rem;
                        line-height: 0.46rem;
                        text-align: center;
                        color: #409EFF;
                        border-radius:0.22rem;
                        border:0.02rem solid rgba(64,158,255,1);
                    }
                }
                .no_task_box {
                    height: 40px;
                    line-height: 40px;
                    color: #999;
                    padding: 0 20px;
                }
            }
        }
        footer{
            position: fixed;
            bottom: 0;
            height: 1rem;
            background-color: #ffffff;
            width: 100vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 0.01333rem solid #f0eeee;
            box-sizing: border-box;
            .footer_left{
                width: 1.8rem;
                min-width: 1.8rem;
                display: flex;
                div{
                    width: 0.9rem;
                    display: flex;
                    flex-direction: column;
                    font-size: 0.22rem;
                    color: #666;
                    text-align: center;
                    img{
                        width: 0.4rem;
                        height: 0.4rem;
                        margin: 0.03rem auto;
                    }
                }
                .yellow_text {
                    color: #FFA904;
                }
            }
            .footer_right{
                width: 100%;
                display: flex;
                .van-button{
                    width: 100%;
                    height: 1rem;
                    line-height: 0.76rem;
                    font-size: 0.3rem;
                    border: none;
                    border-radius: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    .van-button__text{
                        line-height: 0.76rem;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 0.1rem;
                        }
                        &>span:nth-of-type(1){
                            font-size: 0.3rem;
                        }
                        &>span:nth-of-type(2){
                            margin-left: 0.12rem;
                            font-size: 0.26rem;
                            text-decoration: line-through;
                        }
                    }
                    img{
                        width: 0.36rem;
                        height: 0.36rem;
                    }
                }
                .van-button--primary{
                    background:rgba(245,108,108,1);
                }
                .van-button--warning{
                    background:rgba(255,169,4,1);
                    &.openPlus {
                        background: linear-gradient(180deg, #707886 0%, #3D434E 100%);
                        color: #FFE0AF;
                    }
                    &.upgrade {
                        background: linear-gradient(180deg, #6FA0FF 0%, #2A51A3 100%);
                        color: #FFFFFF;
                    }
                }
                .van-button--info{
                    background:rgba(64,158,255,1);
                }
            }

        }
    }
    /*van选项卡样式更改*/
    .van-tabs__line{
        width: 0.5rem!important;
        background-color: rgb(64, 158, 255);
    }
    .van-tab--active .van-tab__text{
        color: rgb(64, 158, 255);
    }
</style>